import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14896b7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card-list-wrap"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card-item-img" }
const _hoisted_4 = { class: "card-item-content" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "extension-info"
}
const _hoisted_7 = {
  key: 2,
  class: "extension-info"
}

import CommonTitleTemplate from '../common-title-template.vue';
import Ellipsis from '@/components/ellipsis.vue';
import BigNoData from '@/components/no-data.vue';
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import TimeShowTemplate from '../time-show-template.vue';
import { computed, onMounted, PropType, reactive, ref } from 'vue';
import { isObject, isString } from 'lodash';
import dayjs from 'dayjs';
import { pageJump } from '@/global/location-transfer';
import { jumpHref } from '@/router/jumpHref';

type Extension = {
    label: string;
    key: string | string[];
    type?: 'dateRange' | 'text' | 'time';
    format?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: {
        type: String,
        default: '',
    },
    imgPos: {
        type: String as PropType<'top' | 'left' | 'right' | 'bottom' | 'full'>,
        default: 'top',
    },
    imgHeight: {
        type: String,
        default: '152px',
    },
    imgWidth: {
        type: String,
        default: '285px',
    },
    coverKey: {
        type: String,
        default: 'cover',
    },
    contentTitleKey: {
        type: String,
        default: 'title',
    },
    extensions: {
        type: Array as PropType<Array<Extension>>,
        default: () => [],
    },
    jumpType: {
        type: String as PropType<'activity' | 'mooc'>,
    },
    request: {
        type: [String, Object] as PropType<string | { name: string; resultKey: string }>,
        default: '',
    },
    requestParams: {
        type: Object as PropType<Record<string, any>>,
        default: () => ({}),
    },
    tagRequest: {
        type: [String, Object] as PropType<string | { name: string; resultKey: string }>,
        default: '',
    },
    tagRequestParams: {
        type: Object as PropType<Record<string, any>>,
        default: () => ({}),
    },
    jumpUrl: {
        type: Object as PropType<{
            path: string | Record<string, any>;
            params?: Array<string>;
        }>,
        default: () => ({}),
    },
    moreUrl: {
        type: Object as PropType<Record<string, any>>,
        default: () => ({}),
    },
    list: {
        type: Array as PropType<any[]>,
        default: () => [],
    },
    itemStyle: {
        type: String,
        default: '',
    },
    columnsNum: {
        type: Number,
        default: 4,
    },
    border: {
        type: Boolean,
        default: true,
    },
    tag: {
        type: Array as PropType<any[]>,
        default: () => [],
    },
    tagConfig: {
        type: Object as PropType<Record<string, any>>,
        default: () => ({}),
    },
},
  setup(__props) {

const props = __props;



const showList = ref<any[]>([]);

const filterData = reactive({
    pageIndex: 1,
    pageSize: 4,
});

const tagList = ref<any>([]);
const defaultTag = ref();

async function getTagList() {
    const { tagRequestParams = {}, tagRequest } = props;
    let list: any = [];
    if (!tagRequest) {
        list = props.tag || [];
        console.error('tagRequest is required');
    } else {
        const requestName = isString(tagRequest) ? tagRequest : tagRequest.name;
        await G_transmit(requestName, {
            params: {
                ...(tagRequestParams.filter?.type === 'query' ? filterData : {}),
                ...(tagRequestParams.params ?? {}),
            },
            data: {
                ...(tagRequestParams.filter?.type === 'body' ? filterData : {}),
                ...(tagRequestParams.data ?? {}),
            },
            message: false,
        }).then(res => {
            if (isObject(tagRequest)) {
                list = getValueByPath(res, tagRequest.resultKey) ?? [];
            } else if (res.data && res.data.rows) {
                list = res.data.rows || [];
            }
            // 配置键值名
            const key = props.tagConfig.key;
            const labelKey = props.tagConfig.label;
            // 过滤配置
            const includes = props.tagConfig?.filter?.includes || [];
            const excludes = props.tagConfig?.filter?.excludes || [];
            // 重组数组
            list = list.map(item => {
                if (key) {
                    item.value = item?.[key];
                    item.tagKey = item?.[key];
                }
                if (labelKey) {
                    item.tagName = item?.[labelKey];
                }
                if (excludes?.length)
                    item.checked = !excludes.some(({ key, value }) => item[key] === value);
                if (includes?.length)
                    item.checked = includes.some(({ key, value }) => item[key] === value);
                return item;
            });
        });
    }
    const defaultValue = list.find?.(item => item?.checked)?.value;
    defaultTag.value = defaultValue;
    tagList.value = list;
    await changeTag(defaultValue);
}

async function changeTag(value) {
    if (props.tagConfig?.valueKey) filterData[props.tagConfig?.valueKey] = value;
    await getList();
}

const getStyle = computed(() => {
    return `
        --img-height: ${props.imgHeight};
        --img-width: ${props.imgWidth};
        --content-width: ${['top', 'bottom'].includes(props.imgPos) ? props.imgWidth : 'auto'};
        --columns-num: ${props.columnsNum};
        --item-border: ${props.border ? '1px solid #eaeaea' : 'none'};
        `;
});

function getValueByPath(obj: any, path: string) {
    const keys = path.split('.');
    if (!keys.length) {
        return;
    }
    if (keys.length === 1) {
        return obj[path];
    }
    const value = keys.reduce((prev, current) => {
        return prev?.[current];
    }, obj);

    return value;
}

async function getList() {
    const { requestParams = {}, request } = props;
    if (!request) {
        showList.value = props.list;
        console.error('request is required');
    } else {
        const requestName = isString(request) ? request : request.name;
        await G_transmit(requestName, {
            params: {
                ...(requestParams.filter?.type === 'query' ? filterData : {}),
                ...(requestParams.params ?? {}),
            },
            data: {
                ...(requestParams.filter?.type === 'body' ? filterData : {}),
                ...(requestParams.data ?? {}),
            },
            message: false,
        }).then(res => {
            if (isObject(request)) {
                showList.value = getValueByPath(res, request.resultKey) ?? [];
            } else if (res.data && res.data.rows) {
                showList.value = res.data.rows || [];
            }
        });
    }
}

function goDetail(item) {
    const { jumpUrl } = props;
    if (!jumpUrl?.path) {
        console.error('jumpUrl is required');
        return;
    }

    if (isString(jumpUrl.path)) {
        const method = getValueByPath(jumpHref, jumpUrl.path);

        if (!method) {
            console.error('method is not exist');
            return;
        }

        pageJump(method(...(jumpUrl.params?.map(key => item[key]) ?? [])), true);

        return;
    }

    if (isObject(jumpUrl.path)) {
        pageJump(jumpUrl.path, true);
    }
}

function moreHandle() {
    const { moreUrl } = props;
    if (!moreUrl?.path) return;
    if (moreUrl?.searchQuerykeys?.length)
        moreUrl.path.query = Object.fromEntries(
            moreUrl.searchQuerykeys.map(key => [key, filterData[key]]),
        );
    pageJump(moreUrl.path, true);
}

const load = ref(false);

onMounted(async () => {
    await getTagList();
    // await getList();
    load.value = true;
});

return (_ctx: any,_cache: any) => {
  return (load.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: "card-list-template",
        style: _normalizeStyle(_unref(getStyle))
      }, [
        _createVNode(CommonTitleTemplate, {
          title: __props.title,
          "tag-list": tagList.value,
          defaultTag: defaultTag.value,
          "tag-config": __props.tagConfig,
          onGoMore: moreHandle,
          onChangeTag: changeTag
        }, null, 8, ["title", "tag-list", "defaultTag", "tag-config"]),
        (showList.value?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  style: _normalizeStyle(__props.itemStyle),
                  class: _normalizeClass([
                    'card-item',
                    {
                        'card-item-img-top': __props.imgPos === 'top',
                        'card-item-img-left': __props.imgPos === 'left',
                        'card-item-img-right': __props.imgPos === 'right',
                        'card-item-img-bottom': __props.imgPos === 'bottom',
                        'card-item-img-full': __props.imgPos === 'full',
                    },
                ]),
                  onClick: ($event: any) => (goDetail(item))
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(LazyImage, {
                      src: item[__props.coverKey],
                      className: "img"
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(Ellipsis, {
                        rows: 2,
                        content: item[__props.contentTitleKey] ?? '-'
                      }, null, 8, ["content"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.extensions, (info, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx + info.key[0]
                      }, [
                        (info.type === 'dateRange')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(info.label) + "：" + _toDisplayString(item[info.key[0]]
                                    ? _unref(dayjs)(item[info.key[0]]).format(info.format ?? 'YYYY.MM.DD')
                                    : '') + "-" + _toDisplayString(item[info.key[1]]
                                    ? _unref(dayjs)(item[info.key[1]]).format(info.format ?? 'YYYY.MM.DD')
                                    : ''), 1))
                          : (info.type === 'time')
                            ? (_openBlock(), _createBlock(TimeShowTemplate, {
                                key: 1,
                                label: info.label,
                                time: 
                                item[info.key as string]
                                    ? _unref(dayjs)(item[info.key as string]).format(
                                          info.format ?? 'YYYY.MM.DD',
                                      )
                                    : '-'
                            
                              }, null, 8, ["label", "time"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(info.label) + "：" + _toDisplayString(getValueByPath(item, info.key as string)), 1))
                      ]))
                    }), 128))
                  ])
                ], 14, _hoisted_2))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(BigNoData, {
              key: 1,
              class: "no-data",
              url: "no-lesson.png",
              info: `暂无数据`
            }))
      ], 4))
    : _createCommentVNode("", true)
}
}

})